import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row, Image, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { IMAGES } from "../../../assets/images/images";
import {
  acceptRejectBookingHost,
  hostBookings,
} from "../../../utility/apiServices/userServices";
import Swal from "sweetalert2";
import { formatDate } from "../../userpanel/propertydetail";
import LoaderHome from "../../../components/loader/homeloader";
import { DateRangePicker } from "react-date-range";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { description } from "../../../utility/local/functions/crypto";

const PropertyBookings = () => {
  const [searchText] = useState("");
  const { t, i18n } = useTranslation()
  const dateRangePickerRef = useRef();
  const [propertyData, setpropertyData] = useState([]);
  const [isDataLoading, setisDataLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(null)
  const currentLanguage = i18n.language;
  const [selectionRange, setSelectionRange] = useState({
    startDate: '',
    endDate: '',
    key: "selection",
  });

  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const bookings = async (page = 1, limit = 10) => {
    const response = await hostBookings({
      startDate: selectionRange?.startDate
        ? format(selectionRange.startDate, "yyyy-MM-dd")
        : "",
      endDate: selectionRange.endDate
        ? format(selectionRange.endDate, "yyyy-MM-dd")
        : "",
      limit
    }, page);
    if (response?.status) {
      setpropertyData(response?.bookings);
      setTotalRecords(response?.totalResults)
    } else {
      Swal.fire({
        icon: "error",
        text: response?.message,
      });
    }
    setisDataLoading(false);
    setLoading(false);
  };


  useEffect(() => {
    setisDataLoading(true);
    bookings(page, limit);
  }, [selectionRange, page, limit]);




  const updateBookingStatus = (bookingId, newStatus) => {
    setpropertyData((prevData) =>
      prevData.map((booking) =>
        booking.id === bookingId ? { ...booking, status: newStatus } : booking
      )
    );
  };
  const acceptRejectBooking = async (
    propertyId,
    bookingId,
    status,
    modelstatus
  ) => {
    Swal.fire({
      title: t("areYouSure"),
      text: t("doYouWantActionBooking", { action: modelstatus }),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("confirmBookingAction", { action: modelstatus }),
      cancelButtonText: t("goBack"),
      preConfirm: async () => {
        try {
          Swal.showLoading();
          const response = await acceptRejectBookingHost({
            bookingId,
            status,
            propertyId,
          });

          setisDataLoading(true);
          bookings();

          return response;

        } catch (error) {
          Swal.fire({
            title: t("errorTitle"),
            text: t("errorMessage"),
            icon: "error",
            confirmButtonText: "OK",
          });
          throw error;
        }
      },
    }).then((result) => {
      console.log(" result:", result);
      if (result.isConfirmed && result.value.status) {
        Swal.fire({
          title: t("bookingStatus", { status: status }),
          text: t("bookingUpdatedSuccess"),
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          updateBookingStatus(bookingId, status);
        });
      } else if (result.isConfirmed) {
        Swal.fire({
          title: "Error",
          text: "There was an error. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    });
  };

  const paginationOptions = {
    rowsPerPageText: t("rowsPerPage"),
    rangeSeparatorText: t("of"),
  };

  const columns1 = [
    {
      name: t("bookings"),
      minWidth: "420px",
      selector: (row) => row.image,
      sortable: true,
      cell: (row) => (
        <div className="d-flex align-items-center tb_content">
          <span className="propertytable_icon">
            <Image alt="" src={row?.Property?.images[0]?.room1[0]?.location} style={currentLanguage === 'he' ? { marginLeft: "1.3rem" } : { marginRight: '1.3rem' }} />
          </span>
          <div className="flex-grow-1">
            <h5>
              {description(row?.Property?.short_description, row?.Property?.short_description_hebrew, i18n.language)}

            </h5>
            <p>
              <Icon icon="system-uicons:location" />
              {row?.Property?.street_address?.length > 30
                ? row?.Property?.street_address.slice(0, 30) + "..."
                : row?.Property?.street_address}
            </p>
            <p className="pColor">
              {/* <Icon icon="flat-color-icons:phone" color="#5c6368" /> */}
              {row?.Property?.phone_number}
            </p>
            <h6>${row?.total_price}</h6>
          </div>
        </div>
      ),
    },
    {
      name: t("bookingDate"),
      selector: (row) => row?.start_date,
      minWidth: "200px",
      sortable: true,
      cell: (row) => {
        const isRTL = false;
        return (
          <p style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
            {isRTL ? (
              <>
                <span>{formatDate(row?.end_date)}</span> - <span>{formatDate(row?.start_date)}</span>
              </>
            ) : (
              <>
                <span>{formatDate(row?.start_date)}</span> - <span>{formatDate(row?.end_date)}</span>
              </>
            )}
          </p>
        );
      },
    },
    
    {
      name: t("bookedDate"),
      selector: (row) => row.createdAt,
      sortable: true,
      cell: (row) => <p>{formatDate(row?.createdAt)}</p>,
    },
    {
      name: t("status"),
      selector: (row) => row?.status,
      sortable: true,
      cell: (row) => (
        <div className="d-flex flex-column align-items-center">
          {row?.status == "pending" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#cce5ff", color: "#004085" }}
              >
                {t("pending")}
              </div>
            </div>
          ) : row?.status == "accepted" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#d4edda", color: "#155724" }}
              >
                {t("confirmed")}
              </div>
            </div>
          ) : row?.status == "accepted" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#d4edda", color: "#155724" }}
              >
                {t("confirmed")}
              </div>
            </div>
          ) : row?.status == "cancelled" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#f8d7da", color: "#721c24" }}
              >
                {t("cancelled")}
              </div>
            </div>
          ) : (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#f8d7da", color: "#721c24" }}
              >
                {t("rejected")}
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      name: t("actions"),
      width: "220px",
      cell: (row) => (
        <div>
          {row?.status == "pending" ? (
            <>
              <div className="">
                <Button
                  className="px-4 "
                  style={{ height: 40, minWidth: 130 }}
                  variant="primary"
                  onClick={() => {
                    acceptRejectBooking(
                      row?.property_id,
                      row?.id,
                      "accepted",
                      "Accept"
                    );
                  }}
                >
                  {t("accept")}
                </Button>

                <Button
                  className="px-4 mt-3"
                  style={{ height: 40, minWidth: 130 }}
                  variant="danger"
                  onClick={() => {
                    acceptRejectBooking(
                      row?.property_id,
                      row?.id,
                      "rejected",
                      "Reject"
                    );
                  }}
                >
                  {t("reject")}
                </Button>
              </div>
            </>
          ) : row?.status == "cancelled" ? (
            <>
              <div className="">
                <Button
                  disabled
                  className="px-4"
                  style={{ height: 40, minWidth: 130 }}
                  variant="danger"
                >
                  {t("cancelled")}
                </Button>
              </div>
            </>
          ) : row?.status == "accepted" ? (
            <>
              <div className="">
                <Button
                  disabled
                  className="px-4"
                  style={{ height: 40, minWidth: 130 }}
                  variant="success"
                >
                  {t("accepted")}
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="">
                <Button
                  disabled
                  className="px-4"
                  style={{ height: 40, minWidth: 130 }}
                  variant="danger"
                >
                  {t("rejected")}
                </Button>
              </div>
            </>
          )}
        </div>
      ),
    },
  ];

  const handleSelect = (ranges) => {
    setSelectionRange(ranges.selection);
  };

  const handleClickOutside = (event) => {
    if (
      dateRangePickerRef.current &&
      !dateRangePickerRef.current.contains(event.target)
    ) {
      setShowDateRangePicker(false);
    }
  };

  useEffect(() => {
    if (showDateRangePicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDateRangePicker]);

  return (
    <React.Fragment>
      <section className="commonpad maincontent_div">
        <Container fluid>
          <div className="proFlex proFlex1">
            <h2 className="mb-0">{t("myBookings")}</h2>
            <div className={currentLanguage === "he" ? "rtlFilterBnt" : 'ltrFilterBtn'} style={{ position: "relative" }}>
              <Link
                className="filterLink1"
                onClick={() => setShowDateRangePicker(!showDateRangePicker)}
              >
                {t("filterByDate")} <Icon icon="solar:calendar-bold" />
              </Link>
              {showDateRangePicker && (
                <>
                  <div
                    className="date-range-container date-range-positionabs flex-column"
                    ref={dateRangePickerRef}
                    style={{
                      position: "absolute",
                      top: "100%",
                      zIndex: 1000,
                    }}
                  >
                    <DateRangePicker
                      ranges={selectionRange.startDate == "" ? [{
                        startDate: new Date(),
                        endDate: new Date(),
                        key: "selection",
                      }] : [selectionRange]}
                      months={2}
                      onChange={handleSelect}
                      direction="vertical"
                      moveRangeOnFirstSelection={false}
                    />
                    <div className="p-2">
                      <button
                        className="close-btn btn btn-primary w-100"
                        onClick={() => setShowDateRangePicker(false)}
                      >
                        {t("filter.close")}
                      </button>
                    </div>
                  </div>
                </>
              )}

            </div>
          </div>
          <Row className="g-4 mt-0">
            <Col md={12}>
              {isDataLoading ? (
                <div className="text-center d-flex justify-content-center">
                  <LoaderHome />
                </div>
              ) : (
                <DataTable
                  columns={columns1}
                  data={propertyData}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRecords}
                  onChangePage={(newPage) => setPage(newPage)}
                  paginationComponentOptions={paginationOptions}
                  onChangeRowsPerPage={(newLimit) => {
                    setLimit((prev) => {
                      if (prev !== newLimit) {
                        setPage(1);
                      }
                      return newLimit;
                    });
                  }}
                  progressPending={loading}
                  noHeader
                  responsive
                  className="tableDataTable"
                />

              )}
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment >
  );
};
export default PropertyBookings;
